// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');
const { CONTRIBUTION_PERIOD_MONTHLY, FIRST_STEP } = require('constants/RAConstants/index');
// utilities
import { formatDateToYYYYMMDD, getDay } from 'utilities/dateHelper/dateHelper';
const todayDate = formatDateToYYYYMMDD(new Date());

const initialState = Immutable.fromJS({
    steps: [
        {
            investmentAmount: 0,
            valid: true,
            errorFlags: false,
        },
        {
            periodicity: CONTRIBUTION_PERIOD_MONTHLY,
            recurringContributionAmount: '',
            contributionDay: getDay(todayDate),
            errorFlags: false,
            valid: false,
        },
        {
            selectedAccount: '',
            accountBalance: {
                amount: 0,
                currency: 'EUR',
            },
            errorFlags: false,
            valid: false,
        },
        {
            disabledCheck: true,
            disclaimerChecked: false,
            buttonDisabled: true,
            errorFlags: false,
            valid: false,
        },
    ],
    visibleStep: FIRST_STEP,
    submitSuccessful: false,
    isFetching: false,
    isDistributionModalOpen: false,
    isPdfModalOpen: false,
    pdfLink: null,
    displaySignaturePatternModel: false,
    annualCost: '0',
    productCost: '0',
});

const RAHireManagerPlan = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_HIRE_MANAGEMENT_PLAN_SET_PDF:
            return state.set('pdfLink', action.payload);
        default:
            return state;
    }
};

module.exports = RAHireManagerPlan;
